import React from 'react';
import { Card, CardContent } from './ui/card';
import { whatWeDoData } from '../data/mockData';
import { Target, MessageSquare, CreditCard } from 'lucide-react';

const iconMap = {
  1: Target,
  2: MessageSquare,
  3: CreditCard
};

const WhatWeDo = () => {
  return (
    <section id="what-we-do" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            {whatWeDoData.sectionTitle}
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed">
            {whatWeDoData.coreStatement}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {whatWeDoData.services.map((service) => {
            const Icon = iconMap[service.id];
            return (
              <Card
                key={service.id}
                className="group overflow-hidden border-slate-200 hover:border-blue-400 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center">
                      <Icon className="h-6 w-6 text-white" />
                    </div>
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-slate-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Key Benefit */}
        <div className="text-center">
          <p className="text-lg md:text-xl font-medium text-blue-700 bg-blue-50 inline-block px-8 py-4 rounded-lg border border-blue-200">
            {whatWeDoData.keyBenefit}
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
